import { render, staticRenderFns } from "./ReviewModifyArticle.vue?vue&type=template&id=01883278"
import script from "./ReviewModifyArticle.vue?vue&type=script&lang=js"
export * from "./ReviewModifyArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports